import React from 'react'
import Header from '../components/Header'

const HeaderLayout = () => {
	return (
		<Header />
	)
}

export default HeaderLayout;